"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _fieldResolver = _interopRequireDefault(require("./field-resolver"));

var _each = _interopRequireDefault(require("lodash/each"));

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _map = _interopRequireDefault(require("lodash/map"));

var _unionBy = _interopRequireDefault(require("lodash/unionBy"));

var _find = _interopRequireDefault(require("lodash/find"));

var _maxBy = _interopRequireDefault(require("lodash/maxBy"));

var _get = _interopRequireDefault(require("lodash/get"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _set = _interopRequireDefault(require("lodash/set"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _first = _interopRequireDefault(require("lodash/first"));

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _fieldOptionsHelper = _interopRequireDefault(require("./field-options-helper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Schema resolve helpers - helps you to interact with the schema definition, get values, transform to react elements, style schema
 *
 * @class SchemaResolver
 */
var SchemaResolver = /*#__PURE__*/function () {
  function SchemaResolver() {
    (0, _classCallCheck2["default"])(this, SchemaResolver);
  }

  (0, _createClass2["default"])(SchemaResolver, [{
    key: "resolve",

    /**
     * Resolve schema definition into react element
     *
     * @param {object} schema - schema definition
     * @param {object} activeFields - !!used as ref!! - activeFields, needed to make sure that each field will only be rendered once
     * @param {Array} hideFieldsByName - optional hideFieldsByName, hide fields that are in this field
     * @returns {element} react element
     *
     * @memberOf SchemaResolver
     */
    value: function resolve(fields, values, additionalFieldTypes, skeletonLoader, disableAutoFocus) {
      // Check if there is a field with autoFocus set to true
      var hasAutoFocus = (0, _find["default"])(fields, function (field) {
        return field.autoFocus;
      }); // Render the fields ordered by the order

      return (0, _map["default"])((0, _sortBy["default"])(fields, function (field) {
        return field.order;
      }), function (field, index) {
        return _fieldResolver["default"].resolve(disableAutoFocus ? field : _objectSpread({
          // When there already is a field with an autoFocus property set, we don’t have to set it to the first field in the loop, because there can only be one field with autoFocus.
          autoFocus: !hasAutoFocus && index === 0
        }, field), values[field.name], additionalFieldTypes, skeletonLoader);
      });
    }
  }, {
    key: "flatternFieldGroupAndRemoveFieldGroupHimSelf",
    value: function flatternFieldGroupAndRemoveFieldGroupHimSelf(fields) {
      var _this = this;

      var arr = [];
      (0, _each["default"])(fields, function (field) {
        if (field.type === 'FieldGroup') {
          if (field.fields) {
            arr = [].concat((0, _toConsumableArray2["default"])(arr), (0, _toConsumableArray2["default"])(_this.flatternFieldGroupAndRemoveFieldGroupHimSelf(field.fields)));
          }
        } else {
          arr.push(field);
        }
      });
      return arr;
    }
  }, {
    key: "validateAndAdjustSchema",
    value: function validateAndAdjustSchema(schema, values, options) {
      // FieldProps, submitErrors, variant
      var newSchema = (0, _cloneDeep["default"])(schema);

      if (!newSchema || !newSchema.fields) {
        return false;
      } // make sure that all name fields are unique


      var fields = newSchema.fields;
      var uniqueFields = (0, _unionBy["default"])(fields, 'name');

      if (fields.length !== uniqueFields.length) {
        console.error('Duplicate fields with the same name', fields, uniqueFields);
        newSchema.fields = uniqueFields;
      } // setup field ref


      this.applyRefToSchema(newSchema.fields); // find the nested fields from the field group
      // todo support mupltiple fieldgroups, but we dont use that yet.., this is just a hack for the domain stuff of Harri

      newSchema.fields = this.flatternFieldGroupAndRemoveFieldGroupHimSelf(newSchema.fields); // HiddenFieldLinks, hide/dont show/filter field when an other field has a certain value

      newSchema.fields = (0, _filter["default"])(newSchema.fields, function (field) {
        var isVisible = true;
        var hiddenFieldLinks = (0, _get["default"])(field, 'hidden_field_links');
        (0, _each["default"])(hiddenFieldLinks, function (hiddenFieldLink) {
          var currentValue = (0, _get["default"])(values, hiddenFieldLink.linked_field); // do not type safe, check. server might send back wrong types.
          // eslint-disable-next-line eqeqeq

          if (hiddenFieldLink.hide_when_value == currentValue) {
            isVisible = false;
          }
        });
        return isVisible;
      }); // setup value in a field

      this.applyValidatorsToFields(newSchema.fields, newSchema);

      if (options.FieldProps) {
        newSchema.fields = (0, _map["default"])(newSchema.fields, function (field) {
          return _objectSpread(_objectSpread({}, options.FieldProps), field);
        });
      } // Apply styling to the fields


      this.applyStylingToSchema(newSchema.fields, newSchema);

      if (options.variant) {
        newSchema.fields = (0, _map["default"])(newSchema.fields, function (field) {
          return _objectSpread({
            variant: options.variant
          }, field);
        });
      } // submitErrors <-- errors returned by the server.


      if (options.submitErrors) {
        var submitErrors = this.convertServerErrorsToInputErrors(options.submitErrors);

        var _loop = function _loop(key) {
          (0, _set["default"])((0, _find["default"])(newSchema.fields, function (field) {
            return (0, _camelCase["default"])(field.fieldId) === (0, _camelCase["default"])(key);
          }), 'validationError', submitErrors[key]);
        };

        for (var key in submitErrors) {
          _loop(key);
        }
      } // validationErrors <-- client side validation error. (onChange or onBlur)


      if (options.validationErrors) {
        var _loop2 = function _loop2(_key) {
          var field = newSchema.fields.find(function (field) {
            return field.fieldId === _key;
          });
          (0, _set["default"])(field, 'validationError', options.validationErrors[_key]);
        };

        for (var _key in options.validationErrors) {
          _loop2(_key);
        }
      } // check for fieldOptions


      (0, _each["default"])(newSchema.fields, function (field) {
        var hasOptionsUrl = (0, _get["default"])(field, 'options_url');

        if (!(0, _isEmpty["default"])(hasOptionsUrl)) {
          var newOptionsUrlToLoad = _fieldOptionsHelper["default"].getOptionsUrlToLoad(newSchema.fields, field, values);

          var oldOptions = options.fieldOptions[field.fieldId];

          if (oldOptions && oldOptions.url === newOptionsUrlToLoad) {
            if (oldOptions.options) {
              // set options for next render
              field.options = oldOptions.options;
            }
          } else {
            // set fieldOptions they will be loaded in PropertyEditor.componentDidMount
            options.fieldOptions[field.fieldId] = {
              url: newOptionsUrlToLoad,
              options: []
            }; // reset options for next render

            field.options = [];
          }
        }
      });
      return newSchema;
    }
    /**
     * Internal - add initial value to each field object, its resolved from the schema.values object that received from the server
     *
     * @param {array} fields - arr of field definitions
     * @param {object} schema - schema definition
     *
     * @memberOf SchemaResolver
     */

  }, {
    key: "applyValidatorsToFields",
    value: function applyValidatorsToFields(fields, schema) {
      if (!schema.values) {
        return;
      }

      (0, _each["default"])(fields, function (field, index) {
        if (field.required) {
          field.validators = field.validators || [];
          var isExisty = (0, _find["default"])(field.validators, function (i) {
            return (i.type || '').toLowerCase() === 'IsExisty'.toLocaleLowerCase();
          });

          if (!isExisty) {
            field.validators.push({
              type: 'IsExisty',
              value: true,
              error_message: 'The {0} field is required.'.replace('{0}', field.label || field.name)
            });
          }
        }
      });
    }
    /**
     * Internal - add ref to each field object, its calculated for linked (child)fields
     *
     * @param {array} fields- arr of field definitions
     * @param {string} prefix - linked (child)fields
     *
     * @memberOf SchemaResolver
     */

  }, {
    key: "applyRefToSchema",
    value: function applyRefToSchema(fields, prefix) {
      var _this2 = this;

      if (prefix) {
        prefix += '.';
      } else {
        prefix = '';
      }

      (0, _each["default"])(fields, function (field, index) {
        // set ref on each field, prefix is most important here
        field.fieldId = prefix + field.name; // Recursive

        if (field.fields) {
          _this2.applyRefToSchema(field.fields, field.fieldId);
        }
      });
    }
    /**
     * Internal - add styling to each field object, its calculated from the scheme.style object
     *
     * @param {array} fields - arr of field definition
     * @param {object} schema - schema definition
     *
     * @memberOf SchemaResolver
     */

  }, {
    key: "applyStylingToSchema",
    value: function applyStylingToSchema(fields, schema) {
      var _this3 = this;

      // check if there is any element with an order
      var maxOrder = (0, _maxBy["default"])(schema.style, function (field) {
        return field.order;
      });
      maxOrder = maxOrder ? maxOrder.order : 0; // foreach element
      // set order
      // set grid system

      (0, _each["default"])(fields, function (field, index) {
        var styleSettings = _this3.getStylingRuleForField(field, schema);

        field.styleSettings = styleSettings;

        if (styleSettings && styleSettings.order !== undefined) {
          field.order = styleSettings.order;
        } else {
          field.order = maxOrder + index;
        } // Recursive


        if (field.fields) {
          _this3.applyStylingToSchema(field.fields, schema);
        }
      });
    }
    /**
     * Get styling rules for one fields, if they are availible in scheme.style
     *
     * @param {object} field - field definition
     * @param {object} schema - schema definition
     * @returns
     *
     * @memberOf SchemaResolver
     */

  }, {
    key: "getStylingRuleForField",
    value: function getStylingRuleForField(field, schema) {
      if (schema.style) {
        return (0, _find["default"])(schema.style, function (styleField) {
          return styleField.name === field.name;
        });
      }
    }
  }, {
    key: "convertServerErrorsToInputErrors",
    value: function convertServerErrorsToInputErrors(serverResponse) {
      var errorObj = {};

      if (serverResponse) {
        var errors = serverResponse.payload;
        (0, _each["default"])(errors, function (fieldError) {
          errorObj[fieldError.field] = (0, _first["default"])(fieldError.errors);
        });
      }

      return errorObj;
    }
  }]);
  return SchemaResolver;
}();

var _default = new SchemaResolver();

exports["default"] = _default;